interface ToastProps {
  message: string | null;
}

export default function Toast({ message }: ToastProps) {
  if (!message) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-24 z-[130] flex justify-center px-4 md:bottom-28">
      <div className="ab-fade-in flex items-center gap-2 rounded-full bg-foreground-900 px-5 py-3 text-sm text-background-50">
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-check-line text-lg text-secondary-300" />
        </span>
        {message}
      </div>
    </div>
  );
}